import React, {useEffect, useState} from 'react';
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {Grid} from '@mui/material';
import {GlassMagnifier} from 'react-image-magnifiers';
import Card from '@mui/material/Card';
import {useNavigate, useParams} from 'react-router';
import Moment from 'react-moment';
import {Images} from '../../../common/Assets/Images';
import {acquisitionsAction} from '../../../services/AcquisitionServices';
import AcquisitionAuditTrails from './AcquisitionAuditTrails';
import AcquisitionDetailActions from './AcquisitionDetailActions';
import DetailPdf from './DetailPdf';
import PageWrapper from '../../../common/PageWrapper/PageWrapper';

export default function AcquisitionDetail() {
  const navigate = useNavigate();
  const params = useParams();
  const id = params?.id;
  const [item, setItem] = useState({});
  const [openLog, setOpenLog] = useState(false);
  const [changeIndex, setChangeIndex] = useState(0);
  const [selectedFile, setSelectedFile] = useState(null);

  useEffect(() => {
    getAcquisitionDetail();
  }, []);

  const getAcquisitionDetail = () => {
    acquisitionsAction('get', id).then(res => {
      setItem(res?.data);
    })
  }

  const handleSelectedIndex = (index) => {
    setChangeIndex(index);
  }

  const toggleLog = () => {
    setOpenLog(!openLog);
  }

  const handleLogClose = () => {
    setOpenLog(false);
  }

  const handleEdit = () => {
    navigate(`/management/acquisitions/create/?id=${id}&isEdit=${true}`)
  }

  const asText = (value) => {
    if (value === null || value === undefined) return '-';
    if (typeof value === 'object') {
      return value?.name || value?.code || value?.description || String(value?.id || '-');
    }
    const str = String(value);
    return str?.trim?.() ? str : '-';
  };

  const pdfDetail = (id) => {
    setSelectedFile(id);
  }

  return (
    <PageWrapper>
      {selectedFile ? <DetailPdf item={item} id={selectedFile} setSelectedFile={setSelectedFile}/>:
      <Box sx={{position: 'relative'}}>
        <Box className={'space-between'} sx={{marginTop: 5}}>
          <Box onClick={() => navigate(-1)}
               className={'flex-cx-center hand-cursor'}>
            <ArrowBackIosRoundedIcon fontSize={'small'} sx={{color: '#757575'}}/>
            <Typography variant={'h5'} sx={{color: '#757575'}}>Acquisition Detail</Typography> &nbsp;
          </Box>
          <AcquisitionDetailActions item={item} handleEdit={handleEdit} acquisitionId={id}/>
        </Box>
        <Box className={'header-divider'}/>
        <Grid container spacing={2}>
          <Grid item sm={5} xs={12}>
            <Card className={'box-shadow'} sx={{width: '100%'}}>
              <GlassMagnifier
                imageSrc={item?.attachments?.[changeIndex]?.file || Images.logoWhite}
                imageAlt="Item Image"
                largeImageSrc={item?.attachments?.[changeIndex]?.file || Images.logoWhite}
                largeImageAlt="Zoomed Image"
                magnifierSize="40%"
                square
              />
            </Card>
            <Grid container spacing={1} sx={{mt: 0.5}}>
              {item?.attachments?.length > 0 && item?.attachments?.map((attachment, index) => (
                attachment.type !== 'application/pdf' && (
                <Grid item sm={2.4} key={index}>
                  <Card sx={{height: 100}}>
                    <img onClick={() => handleSelectedIndex(index)} draggable={false} width={'100%'} height={'100%'}
                         style={{borderRadius: 5, objectFit: 'contain'}}
                         src={attachment?.file || Images?.logoWhite}
                         alt="item_image"/>
                  </Card>
                </Grid>
                )
              ))}
            </Grid>
          </Grid>
          <Grid item sm={7} xs={12}>
            <Card className={'box-shadow'}>
              <Box sx={{p: 2}}>
                <Typography className={'font20 text-500 dark-color'}>Acquisition Data</Typography>
              </Box>
              <Box className={'common-divider'}/>
              <Box sx={{p: 2}}>
                <Grid container spacing={2} sx={{mb: 0.5}}>
                  <Grid item sm={4}>
                    <Typography className={'dark-color font-15 text-500'}>ACQUISITION TYPE:</Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Typography className={'font-15 text-capitalize'}>{asText(item?.acquisition_type || item?.acquisition_type_legacy)}</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{mb: 0.5}}>
                  <Grid item sm={4}>
                    <Typography className={'dark-color font-15 text-500'}>OWNER:</Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Typography className={'font-15 text-capitalize'}>{item?.owner}</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{mb: 0.5}}>
                  <Grid item sm={4}>
                    <Typography className={'dark-color font-15 text-500 text-capitalize'}>RECEIVED FROM: </Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Typography className={'font-15'}>{item?.received_from}</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{mb: 0.5}}>
                  <Grid item sm={4}>
                    <Typography className={'dark-color font-15 text-500'}>PERMANENT ADDRESS:</Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Typography className={'font-15 text-capitalize'}>{item?.permanent_address}</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{mb: 0.5}}>
                  <Grid item sm={4}>
                    <Typography className={'dark-color font-15 text-500'}>VILLAGE, GEWOG, Chiwog:</Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Typography
                      className={'font-15 text-capitalize'}>{item?.village_name}, {item?.gewog_name}, {item?.chiwog}</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{mb: 0.5}}>
                  <Grid item sm={4}>
                    <Typography className={'dark-color font-15 text-500'}>DZONGKHAG:</Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Typography className={'font-15 text-capitalize'}>{item?.dzongkhag_name}</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{mb: 0.5}}>
                  <Grid item sm={4}>
                    <Typography className={'dark-color font-15 text-500'}>DATE OF ENTRY:</Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Typography className={'font-15'}><Moment format={'ll'}>{item?.date_of_entry}</Moment></Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{mb: 0.5}}>
                  <Grid item sm={4}>
                    <Typography className={'dark-color font-15 text-500'}>PRICE:</Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Typography className={'font-15'}>Nu. {item?.price}</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{mb: 0.5}}>
                  <Grid item sm={4}>
                    <Typography className={'dark-color font-15 text-500'}>APPRAISED VALUE:</Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Typography className={'font-15'}>Nu. {item?.appraised_value}</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{mb: 0.5}}>
                  <Grid item sm={4}>
                    <Typography className={'dark-color font-15 text-500'}>ESTIMATED BY:</Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Typography className={'font-15'}>{item?.user_name || '-'}</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{mb: 0.5}}>
                  <Grid item sm={4}>
                    <Typography className={'dark-color font-15 text-500'}>STORAGE:</Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Typography className={'font-15'}>
                      {item?.storage}</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{mb: 0.5}}>
                  <Grid item sm={4}>
                    <Typography className={'dark-color font-15 text-500'}>LOCATION:</Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Typography className={'font-15'}>{item?.location}</Typography>
                  </Grid>
                </Grid>
              </Box>
            </Card>
            <Card className={'box-shadow'} sx={{p: 2, mt: 1}}>
              <Typography className={'dark-color font-15 text-500'}>REMARKS</Typography>
              <Typography className={'font-14'}>{item?.remarks || '-'}</Typography>
            </Card>
            {/*<Card className={'box-shadow'} sx={{p: 2, mt: 1}}>*/}
            {/*  <Typography className={'dark-color font-15 text-500'}>PDF Files</Typography>*/}
            {/*  {item?.attachments?.length > 0 && item.attachments.map((attachment, index) => (*/}
            {/*    attachment.type === 'application/pdf' && (*/}
            {/*      <Box key={index} className={'hand-cursor'}*/}
            {/*           onClick={() => pdfDetail(attachment?.id)}>{attachment?.name}</Box>*/}
            {/*    )*/}
            {/*  ))}*/}
            {/*</Card>*/}
          </Grid>
        </Grid>
        <Box sx={{position: 'fixed', right: 0, bottom: '10%'}}>
          <Card onClick={toggleLog} className={'box-shadow'}
                sx={{
                  pr: 2.5,
                  pl: 2,
                  pt: 1,
                  pb: 1.5,
                  zIndex: 20000,
                  backgroundColor: '#616B88',
                  borderTopLeftRadius: 50,
                  borderBottomLeftRadius: 50,
                  cursor: 'pointer',
                }}>
            <ArrowBackIosNewRoundedIcon fontSize={'small'} sx={{color: '#fff', marginTop: 1}}/>
          </Card>
        </Box>
        <AcquisitionAuditTrails openLog={openLog} handleLogClose={handleLogClose} acquisitionId={id}/>
      </Box>}
    </PageWrapper>
  );
}